import { AllMarketTypes } from '../enums';

const marketTypeToNameEnum = {
  [AllMarketTypes.Red_2]: 'RED 2',
  [AllMarketTypes.Black_2]: 'BLACK 2',
  [AllMarketTypes.Number_2]: '2',
  [AllMarketTypes.Hi_2]: 'HIGH 2',
  [AllMarketTypes.Red_3]: 'RED 3',
  [AllMarketTypes.Black_3]: 'BLACK 3',
  [AllMarketTypes.Number_3]: '3',
  [AllMarketTypes.Hi_3]: 'HIGH 3',
  [AllMarketTypes.Lo_3]: 'LO 3',
  [AllMarketTypes.Red_4]: 'RED 4',
  [AllMarketTypes.Black_4]: 'Black 4',
  [AllMarketTypes.Number_4]: '4',
  [AllMarketTypes.Hi_4]: 'HIGH 4',
  [AllMarketTypes.Lo_4]: 'LO 4',
  [AllMarketTypes.Red_5]: 'RED 5',
  [AllMarketTypes.Black_5]: 'BLACK 5',
  [AllMarketTypes.Number_5]: '5',
  [AllMarketTypes.Hi_5]: 'HIGH 5',
  [AllMarketTypes.Lo_5]: 'Lo 5',
  [AllMarketTypes.Red_6]: 'Red 6',
  [AllMarketTypes.Black_6]: 'BLACK 6',
  [AllMarketTypes.Number_6]: '6',
  [AllMarketTypes.Hi_6]: 'HIGH 6',
  [AllMarketTypes.Lo_6]: 'LO 6',
  [AllMarketTypes.Red_7]: 'RED 7',
  [AllMarketTypes.Black_7]: 'BLACK 7',
  [AllMarketTypes.Number_7]: '7',
  [AllMarketTypes.Hi_7]: 'HIGH 7',
  [AllMarketTypes.Lo_7]: 'LO 7',
  [AllMarketTypes.Red_8]: 'RED 8',
  [AllMarketTypes.Black_8]: 'BLACK 8',
  [AllMarketTypes.Number_8]: '8',
  [AllMarketTypes.Hi_8]: 'HIGH 8',
  [AllMarketTypes.Lo_8]: 'LO 8',
  [AllMarketTypes.Red_9]: 'RED 9',
  [AllMarketTypes.Black_9]: 'BLACK 9',
  [AllMarketTypes.Number_9]: '9',
  [AllMarketTypes.Hi_9]: 'HIGH 9',
  [AllMarketTypes.Lo_9]: 'LO 9',
  [AllMarketTypes.Red_J]: 'RED J',
  [AllMarketTypes.Black_J]: 'BLACK J',
  [AllMarketTypes.J]: 'J',
  [AllMarketTypes.Hi_J]: 'HIGH J',
  [AllMarketTypes.Lo_J]: 'LO J',
  [AllMarketTypes.Red_Q]: 'RED Q',
  [AllMarketTypes.Black_Q]: 'BLACK Q',
  [AllMarketTypes.Q]: 'Q',
  [AllMarketTypes.Hi_Q]: 'HIGH Q',
  [AllMarketTypes.Lo_Q]: 'LO Q',
  [AllMarketTypes.Red_K]: 'RED K',
  [AllMarketTypes.Black_K]: 'BLACK K',
  [AllMarketTypes.K]: 'K',
  [AllMarketTypes.Hi_K]: 'HIGH K',
  [AllMarketTypes.Lo_K]: 'LO K',
  [AllMarketTypes.Red_A]: 'RED A',
  [AllMarketTypes.Black_A]: 'BLACK A',
  [AllMarketTypes.A]: 'A',
  [AllMarketTypes.Lo_A]: 'LO A',
  [AllMarketTypes.Red]: 'RED',
  [AllMarketTypes.Black]: 'BLACK',
  [AllMarketTypes.Numbers_2_to_9]: '2-9',
  [AllMarketTypes.Joker]: 'JOKER',
  [AllMarketTypes.J_Q_K_A]: 'J,Q,K,A',
  [AllMarketTypes.J_Q]: 'J,Q',
  [AllMarketTypes.K_A]: 'K,A',
};

export const marketTypeToName = (marketType, t) => {
  const marketName = marketTypeToNameEnum[marketType] || '';
  const [key, value] = marketName.split(' ');
  const trValue = t(key);
  return value ? `${trValue} ${value}` : trValue;
};
